<template>
  <transition name="animation-opacity">
    <CallButtonStickyPanel @click="activeCurrentPodcast()" v-if="!isPanelOpen" />
  </transition>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { useUserAuth } from '@/Groups/Audioplayer/private/imports/externalStoreData';
  import { useAudioPlayerState } from '@/Groups/Audioplayer/private/composables/computedValues';
  //---------------------
  import CallButtonStickyPanel from '@/Groups/Audioplayer/private/core/CallButtonStickyPanel/CallButtonStickyPanel.vue';
  //---------------------
  const store = useStore();
  //---------------------
  const { hasPaidAccount } = useUserAuth();
  //---------------------
  const { isPanelOpen, isReady } = useAudioPlayerState();
  //---------------------
  //Вызвать панель плеера
  const activeCurrentPodcast = () => {
    if(!hasPaidAccount.value) return;
    if(!isReady.value) return;
    store.dispatch('Audioplayer/resumeAudio');
  } 
</script>

<style scoped lang="scss">
  @import './styles.scss';
</style>